import { render, staticRenderFns } from "./Appropriation.vue?vue&type=template&id=8c54dbf8"
import script from "@/controllers/ap/reconciliation/appropriation/Appropriation?vue&type=script&lang=ts&external"
export * from "@/controllers/ap/reconciliation/appropriation/Appropriation?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports